import Collapse from 'antd/lib/collapse';

const { Panel } = Collapse;

const FAQ = () => {
  const questions = [
    {
      q: '¿Dónde está su dirección en USA?',
      a: 'En Miami, FL. Se te proporciona al contáctarnos.',
    },
    {
      q: '¿Cuánto tarda en llegar mi paquete?',
      a: 'Entre 3 a 5 días hábiles Aéreo y 20 a 25 días hábiles Maritimo dependiendo del tamaño y ciudad destino.',
    },
    {
      q: '¿Aceptan compras por mí?',
      a: 'Sí, ofrecemos asistencia para compras con 50% del costo del producto.',
    },
  ];

  return (
    <div className="py-5">
      <h2 className="text-center mb-4">Preguntas Frecuentes</h2>
      <Collapse accordion defaultActiveKey={0}>
        {questions.map((item, index) => (
          <Panel header={item.q} key={index}>
            <p>{item.a}</p>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default FAQ;